import { both, propEq, propSatisfies } from 'ramda';

import { isWaybetterProduct } from '../utils';

export const isProductMember = both(
  propSatisfies(isWaybetterProduct, 'product'),
  propEq('isActiveWbMember', true)
);
